import { C as n } from "./product-utils-BZ9FKiCb.js";
import { useEffect as u } from "react";
function m({ bgColor: t = n.white, color: l = n.black }) {
  let e, r, c;
  const { style: o } = document.documentElement, a = () => {
    e ? s() : d();
  }, i = () => {
    c = o.getPropertyValue("--drawer-bg-color"), r = o.getPropertyValue("--drawer-color");
  }, d = () => {
    i(), o.setProperty("--drawer-bg-color", t), o.setProperty("--drawer-color", l), e = !0;
  }, s = () => {
    e && (o.setProperty("--drawer-bg-color", c), o.setProperty("--drawer-color", r), e = !1);
  };
  return {
    toggleColor: a,
    revertColor: s
  };
}
function w(t, l) {
  u(() => {
    const e = (r) => {
      r.composedPath().some((o) => o === t.current) || l();
    };
    return window.document.addEventListener("click", e), () => window.document.removeEventListener("click", e);
  });
}
export {
  w as a,
  m as u
};
